import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn — className helper combining clsx + tailwind-merge.
 *
 * Resolves conditional classes (`cn("base", isActive && "active")`) and
 * merges Tailwind utility conflicts so the last-one-wins rule applies
 * (e.g. `cn("px-4", "px-6")` resolves to `px-6`).
 *
 * Used by every component that takes className / class overrides.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
